<template>
  <div id="ExternalTicketDownload" class="fullheight bg-light">
    <CContainer v-if="event && guest" fluid class="fullheight px-0">
      <CRow class="fullheight no-gutters">

        <!-- Columna izquierda: Info del evento -->
        <CCol md="6" class="left-column d-flex align-items-center justify-content-center">
          <div class="content-wrapper text-center p-4">
            <!-- Imagen -->
            <img
              v-if="isImage"
              :src="event.image"
              alt="Invitación"
              class="event-image"
            />

            <!-- PDF -->
            <div
              v-else-if="isPdf"
              class="pdf-placeholder d-flex flex-column align-items-center justify-content-center bg-white shadow-sm rounded p-5"
            >
              <h3><strong> {{event.name}}</strong></h3>
              <p class="display-4 mb-3">📄</p>
              <p class="font-weight-bold mb-2">Invitación en PDF</p>
              <p class="text-muted mb-3">Descárgala para verla completa</p>

              <CButton color="info">
                Descargar invitación
              </CButton>
            </div>
            <!-- Fallback -->
            <div
              v-else
              class="event-info text-left p-4 rounded bg-white shadow-sm"
              style="max-width: 500px;"
            >
              <h2 class="mb-3">{{ event.name }}</h2>

              <p class="mb-1">
                <strong>📅 Fecha:</strong> {{ formattedDate }}
              </p>

              <p class="mb-1" v-if="event.start_hour && event.end_hour">
                <strong>🕒 Hora:</strong> {{ event.start_hour }} - {{ event.end_hour }}
              </p>

              <p class="mb-1" v-if="event.address">
                <strong>📍 Lugar:</strong> {{ event.address }}
              </p>

              <p class="mt-3" v-if="event.description">
                {{ event.description }}
              </p>

              <p class="text-muted mt-4" v-if="event.planner_name">
                Organiza: {{ event.planner_name }}
              </p>
            </div>
          </div>
        </CCol>

        <!-- Columna derecha: Descarga de boletos -->
        <CCol md="6" class="right-column d-flex align-items-center justify-content-center">
          <div class="form-container bg-white shadow p-5 rounded" style="width: 100%; max-width: 450px;">
            <div class="text-center mb-3">
              <img src="logo_confirmame.png" alt="Logo Confirmame" class="logo-img" />
            </div>

            <h3 class="mb-3 text-center">🎟️ Tus boletos</h3>

            <p class="text-center text-muted mb-4">
              {{ guest.name }}
            </p>

            <div v-if="tickets.length">
              <div
                v-for="ticket in tickets"
                :key="ticket.id"
                class="ticket-box p-3 mb-3 border rounded"
              >
                <p class="mb-2 font-weight-bold">
                  Boleto {{ ticket.folio }}
                </p>

                <CButton
                  v-if="ticket.pdf_url"
                  color="info"
                  class="w-100"
                  @click="downloadPDF(ticket)"
                >
                  Descargar PDF
                </CButton>
              </div>
            </div>

            <p v-else class="text-muted text-center">
              No hay boletos disponibles para descargar.
            </p>
          </div>
        </CCol>

      </CRow>
    </CContainer>

    <loading :active="visible" loader="bars"></loading>

   <CToaster placement="top-end">
      <template>
        <CToast v-for="(toast, key) in toasts" :color="toast.color" v-bind="toast" :key="'toast' + key" :show="true">
          {{ toast.content }}
        </CToast>
      </template>
    </CToaster>
  </div>
</template>


<script>
import guestsService from "@/services/events_guests.js";
import store from "../../store";
import router from "@/router";
import Loading from "vue-loading-overlay/dist/vue-loading.js";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ExternalTicketDownload",
  components: { Loading },

  data() {
    return {
      event: null,
      guest: null,
      tickets: []
    };
  },

  async mounted() {
    await this.loadTickets();
  },
  computed: {
    isPdf() {
      return this.event?.image?.toLowerCase().endsWith('.pdf')
    },
    isImage() {
      return this.event?.image && !this.isPdf
    },
    formattedDate() {
      if (!this.event) return "";
      return new Date(this.event.date).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    visible() {
      return store.state.isLoading;
    },
    toasts() {
      return store.state.toasts;
    }
  },

  methods: {
    async loadTickets() {
      this.loading();
      try {
        const token = this.$route.params.code;

        const response = await guestsService.getDownloadExternalTickets(token);

        if (response.type === "success") {
          this.event = response.data.event;
          this.guest = response.data.guest;
          this.tickets = response.data.tickets;
        } else {
          router.push({ name: "404" });
        }
      } catch (e) {
        router.push({ name: "404" });
      }
      this.loaded();
    },

    downloadPDF(ticket) {
      window.open(ticket.pdf_url, "_blank");
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit("loading");
    },
    loaded() {
      store.commit("loaded");
    }
  }
};
</script>

<style scoped>
.fullheight {
  min-height: 100vh;
}

.bg-light {
  background-color: #f7f0e6;
}

.left-column,
.right-column {
  background-color: #f7f0e6;
  padding: 2rem;
}

.event-image {
  max-height: 600px;
  max-width: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo-img {
  width: 180px;
  margin: auto;
  display: block;
}

.ticket-box {
  background-color: #fafafa;
}
.ticket-box {
  background-color: #fafafa;
}

.pdf-placeholder {
  max-width: 500px;
  width: 100%;
  min-height: 400px;
  text-align: center;
}

</style>
